<template>
  <ComparisonLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/compare/honeybook-vs-dubsado.mjs";
</script>
